<div class="upload-graphics-thumbnail-container">
  <div class="upload-graphics-container">
    <label class="upload-graphics-header">Upload Graphics</label>
    <div class="graphics-name">
      <label class="graphics-name-label">Graphics Name:</label>
      <input
        [disabled]="isUploadingGraphics"
        class="graphics-name-input"
        [(ngModel)]="graphicsName"
        placeholder="Enter Graphics Name..."
      />
    </div>

    <textarea
      [disabled]="isUploadingGraphics"
      class="graphics-description-textarea"
      [(ngModel)]="graphicsDescription"
      placeholder="Enter Graphics Description..."
    ></textarea>
    <div class="input-file-container">
      <input
        [disabled]="isUploadingGraphics"
        id="graphicsFile"
        class="input-graphics-file"
        type="file"
        accept=".zip"
        (change)="onGraphicsInputFileChange($event)"
      />
      <label for="graphicsFile">Choose File</label>
      <label class="file-chosen">{{graphicsFileChosenName}}</label>
    </div>
    <button
      [disabled]="isUploadingGraphics"
      class="btn btn-upload"
      (click)="uploadGraphics()"
    >
      Upload
    </button>

    <label [ngStyle]="{'margin-top' : '30px'}" class="upload-graphics-header"
      >Delete Graphics</label
    >
    <div class="graphics-name">
      <label class="graphics-name-label">Graphics Name:</label>
      <icn-dropdown
        class="graphics-dropdown"
        [(selectedValue)]="graphicsDeleteChosenId"
        [position]="'bottom'"
      >
        <icn-dropdown-item
          *ngFor="let graphic of graphics; let index = index"
          [title]="graphic.name"
          [value]="graphic.id"
        >
        </icn-dropdown-item>
      </icn-dropdown>
    </div>
    <button
      [disabled]="isDeletingGraphics"
      class="btn btn-upload"
      (click)="deleteGraphics()"
    >
      Delete
    </button>

    <label [ngStyle]="{'margin-top' : '30px'}" class="upload-graphics-header"
      >Update Rendition Validity Period</label
    >
    <div class="graphics-name">
      <label class="graphics-name-label">Graphics Name:</label>
      <icn-dropdown
        class="graphics-dropdown"
        [(selectedValue)]="updateRenditionValidityPeriodGraphicsChosenId"
        [position]="'bottom'"
      >
        <icn-dropdown-item
          *ngFor="let graphic of graphics; let index = index"
          [title]="graphic.name"
          [value]="graphic.id"
        >
        </icn-dropdown-item>
      </icn-dropdown>
      <div
        class="graphics-name"
        *ngIf="updateRenditionValidityPeriodGraphicsChosenId > 0"
      >
        <label class="graphics-name-label">Rendition Validity Period</label>
        <evrideo-time-editor
          [(valueMs)]="chosenRenditionValidityPeriodMs"
          [fontSize]="'18px'"
          [height]="'21px'"
          [minMs]="0"
          [fullMode]="true"
          [type]="'MS'"
        ></evrideo-time-editor>
      </div>
    </div>
    <button
      [disabled]="isUpdatingGraphics"
      class="btn btn-upload"
      (click)="updateRenditionValidityPeriod()"
    >
      Update
    </button>
  </div>

  <div class="upload-graphics-container">
    <div class="upload-thumbnail-font-container">
      <label class="upload-graphics-header">Upload Thumbnail</label>
      <div class="graphics-name">
        <label class="graphics-name-label">Graphics Name:</label>
        <icn-dropdown
          class="graphics-dropdown"
          [(selectedValue)]="graphicsChosenId"
          [position]="'bottom'"
        >
          <icn-dropdown-item
            *ngFor="let graphic of graphics; let index = index"
            [title]="graphic.name"
            [value]="graphic.id"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
      <div class="input-file-container">
        <input
          [disabled]="isUploadingThumbnail || isDeletingGraphics"
          id="thumbnailFile"
          class="input-graphics-file"
          type="file"
          accept="image/*"
          (change)="onThumbnailInputFileChange($event)"
        />
        <label for="thumbnailFile">Choose File</label>
        <label class="file-chosen">{{thumbnailFileChosenName}}</label>
      </div>
      <button
        [disabled]="isUploadingThumbnail"
        class="btn btn-upload"
        (click)="uploadThumbnail()"
      >
        Upload
      </button>

      <label [ngStyle]="{'margin-top' : '30px'}" class="upload-graphics-header"
        >Upload Font</label
      >
      <div class="graphics-name">
        <label class="graphics-name-label">Font Name:</label>
        <input
          [disabled]="isUploadingFont || !isFileChosen"
          class="graphics-name-input"
          [(ngModel)]="fontName"
          placeholder="Enter Font Name..."
        />
      </div>
      <div class="input-file-container">
        <input
          [disabled]="isUploadingFont"
          id="fontFile"
          class="input-graphics-file"
          type="file"
          accept=".ttf, .otf"
          (change)="onFontInputFileChange($event)"
        />
        <label for="fontFile">Choose File</label>
        <label class="file-chosen">{{fontFileChosenName}}</label>
      </div>
      <button
        [disabled]="isUploadingFont"
        class="btn btn-upload"
        (click)="uploadFont()"
      >
        Upload
      </button>

      <label [ngStyle]="{'margin-top' : '30px'}" class="upload-graphics-header"
        >Upload Sample Video</label
      >
      <div class="graphics-name">
        <label class="graphics-name-label">Graphics Name:</label>
        <icn-dropdown
          class="graphics-dropdown"
          [(selectedValue)]="graphicsUploadSampleVideoId"
          [position]="'bottom'"
        >
          <icn-dropdown-item
            *ngFor="let graphic of graphics; let index = index"
            [title]="graphic.name"
            [value]="graphic.id"
          >
          </icn-dropdown-item>
        </icn-dropdown>
      </div>
      <div class="input-file-container">
        <input
          [disabled]="isUploadingSampleVideo || isDeletingGraphics"
          id="sampleVideoFile"
          class="input-graphics-file"
          type="file"
          accept="video/mp4"
          (change)="onSampleVideoInputFileChange($event)"
        />
        <label for="sampleVideoFile">Choose File</label>
        <label class="file-chosen">{{sampleVideoFileChosenName}}</label>
      </div>
      <button
        [disabled]="isUploadingSampleVideo"
        class="btn btn-upload"
        (click)="uploadSampleVideo()"
      >
        Upload
      </button>
    </div>
  </div>
</div>
